import { render, staticRenderFns } from "./ss-activity-detail.vue?vue&type=template&id=928e1cc6&scoped=true&"
import script from "./ss-activity-detail.vue?vue&type=script&lang=js&"
export * from "./ss-activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./ss-activity-detail.vue?vue&type=style&index=0&id=928e1cc6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928e1cc6",
  null
  
)

export default component.exports